module.exports = "<button class=\"kd-icon\"\r\n    type=\"button\"\r\n    title=\"Cambiar tema de interface\"\r\n    ng-click=\"$ctrl.toggle()\">\r\n  <i ng-class=\"{'fas fa-moon': $ctrl.isNight, 'far fa-moon': !$ctrl.isNight}\"></i>\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/components/theme-switch/template.html
// module id = 175
// module chunks = 0